import * as React from 'react';
import * as Loadable from 'react-loadable';
import { LoadingSpinner } from '@common/components';

export const AsyncContract = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.Contract),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncContract2 = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractWithHostedCheckout),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

// export const AsyncContractSearch = Loadable({
//     loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractSearch),
//     loading: () => <LoadingSpinner />,
//     render: (loaded: any, props: any) => {
//         let Component = loaded;
//         return <Component {...props} />;
//     },
//     delay: 300,
//     timeout: 10000
// });

export const AsyncContractCancellation = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractCancellation),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncOrderEdit = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.OrderEdit),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncContractDetails = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractDetails),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncContractNoRenew = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractNoRenew),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncContractTransfer = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractTransfer),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncQuote = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/quote').then(m => m.Quote),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncRenewalWithChanges = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/renewal').then(m => m.RenewalWithChanges),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncRenewalNoChanges = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/renewal').then(m => m.RenewalNoChanges),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncQuoteSearch = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/quote').then(m => m.QuoteSearch),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncQuoteDetails = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/quote').then(m => m.QuoteDetails),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncContractEmail = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractEmail),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPaymentEdit = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.PaymentEdit),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncContractBalances = Loadable({
  loader: () => import(/* webpackChunkName: "ContractModule" */ 'src/contract').then(m => m.ContractBalances),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});



// WEBPACK FOOTER //
// ./src/_Modules/contract.module.tsx